import script from "./ContrattoWizard.vue?vue&type=script&setup=true&lang=js"
export * from "./ContrattoWizard.vue?vue&type=script&setup=true&lang=js"

import "./ContrattoWizard.vue?vue&type=style&index=0&id=06b52e62&scoped=true&lang=scss"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06b52e62"]])

export default __exports__